<template>
  <div class="welfare">
    <div class="title">
      <div class="titleT">企业福利专区</div>
      <div class="titleA"><a href="welfare.html">立即体验<span class="iconfont icon-shuangjiantou"></span></a></div>
    </div>
    <ul>
      <li v-for="(i,index) in list" :key="index">
        <div class="img"><img :src="i.img"></div>
        <div class="name">{{i.name}}</div>
        <div class="button">立即体验</div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'welfare',
  data () {
    return {
      list: [{
        name: '年节专区',
        img: require('../../../assets/img/index/welfare1.png'),
        url: ''
      }, {
        name: '传统卡册',
        img: require('../../../assets/img/index/welfare2.png'),
        url: ''
      }, {
        name: '瀚礼E卡',
        img: require('../../../assets/img/index/welfare3.png'),
        url: ''
      }, {
        name: '福利集采专区',
        img: require('../../../assets/img/index/welfare4.png'),
        url: ''
      }]
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>
<style lang="stylus" scoped>
.welfare
  padding 0 px(20)
  margin-top px(60)
  ul
    display flex
    margin-top px(40)
    justify-content space-between
    li
      width px(170)
      border 1px solid #D9D9D9
      .name
        width 100%
        font-size px(24)
        color #333333
        text-align center
        margin-top px(25)
      .button
        width px(110)
        height px(34)
        background #FF9900
        border-radius px(6)
        color #fff
        text-align center
        margin px(20) auto
        font-size px(20)
        display flex
        align-items center
        justify-content center
      .img
        text-align center
        margin-top px(26)
        img
          height px(60)
</style>



// WEBPACK FOOTER //
// src/pages/index/components/welfare.vue